// Keenthemes' plugins
window.KTComponents = require('@/js/components/_init.js');
window.KTUtil = require('@/js/components/util.js');
window.KTApp = require('@/js/components/app.js');
window.KTEventHandler = require('@/js/components/event-handler.js');
window.KTBlockUI = require('@/js/components/blockui.js');
window.KTCookie = require('@/js/components/cookie.js');
window.KTDialer = require('@/js/components/dialer.js');
window.KTDrawer = require('@/js/components/drawer.js');
window.KTFeedback = require('@/js/components/feedback.js');
window.KTImageInput = require('@/js/components/image-input.js');
window.KTMenu = require('@/js/components/menu.js');
window.KTPasswordMeter = require('@/js/components/password-meter.js');
window.KTScroll = require('@/js/components/scroll.js');
window.KTScrolltop = require('@/js/components/scrolltop.js');
window.KTSearch = require('@/js/components/search.js');
window.KTStepper = require('@/js/components/stepper.js');
window.KTSticky = require('@/js/components/sticky.js');
window.KTSwapper = require('@/js/components/swapper.js');
window.KTToggle = require('@/js/components/toggle.js');

// Layout base js
window.KTAppSidebar = require('@/js/layout/sidebar.js');
window.KTLayoutSearch = require('@/js/layout/search.js');
window.KTLayoutToolbar = require('@/js/layout/toolbar.js');
window.KTThemeMode = require('@/js/layout/theme-mode.js');
window.KTThemeModeUser = require('@/js/layout/theme-mode-user.js');
